import React from "react";
import { STAFF_MANDATE_ENABLED } from "../../../config/featureFlags";
import TabBar from "../v2/TabBar";

// My Agency V2 mobile tab chrome (ARTBOARD-SPEC CMP-TABS mobile variant,
// boards 1l/2j). PRESENTATION-ONLY restyle: tab keys, onTabChange wiring
// and the STAFF_MANDATE_ENABLED gating are identical to the previous
// version (Brief Rule 6). `counts` optional — null hides the pill.
const AgencyProfileMobileTabs = ({ activeTab, onTabChange, counts = {} }) => {
  const tabs = [
    { key: "agents", label: "Agents", count: counts.agents ?? null },
    { key: "players", label: "Players", count: counts.players ?? null },
    // TP-Coach-Mandate: flag-gated Staff tab (mobile twin of the desktop
    // AgencyTabs addition).
    ...(STAFF_MANDATE_ENABLED
      ? [{ key: "staff", label: "Staff", count: counts.staff ?? null }]
      : []),
    { key: "partners", label: "Partners", count: counts.partners ?? null },
  ];

  return (
    <TabBar
      tabs={tabs}
      activeKey={activeTab}
      onChange={onTabChange}
      mobile
      className="px-4 bg-transparent"
    />
  );
};

export default AgencyProfileMobileTabs;
